module.exports = __webpack_public_path__ + "img/sld_scb_12_t1_b1.eb477e8d.svg";